module.exports = __webpack_public_path__ + "bddb44e23de420223ae3e0838e4ea498.MP3";